

import { AfterContentInit, AfterViewInit, Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NicaMaster } from '../nica-master-component/nica-master.component';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { AnagraficaService } from '../../services/anagrafica.service';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})

export class TestComponent extends NicaMaster implements OnInit, AfterContentInit {
  titolo: string = ''
  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    private activeRoute: ActivatedRoute
  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,
    )
  }
  ngAfterContentInit(): void {
  }

  ngOnInit(): void {
    this.activatedroute.queryParams
      .subscribe(params => {
        this.currentTabId = params.currentTabId;
        this.currentTabName = params.currentTabName;
        this.setGlobalVariableFromParams(params);
      });
    this.activeRoute.data.subscribe(x => { return this.titolo = x['titolo'] || 'Titolo' })

  }
}
